import { useSelector } from 'react-redux';
import { State } from 'moduleBase/types/State';
import { InitResponse } from 'moduleBase/actions/types/InitResponseType';
import { REDUCER_GLOBAL_NAME } from 'moduleBase/constants';
import { useEffect } from 'react';

const SatisMeter = () => {
  const satisMeterData = useSelector<State, InitResponse['satisMeterData']>(
    (state) => state[REDUCER_GLOBAL_NAME].satisMeterData,
  );

  useEffect(() => {
    if (!satisMeterData) {
      return null;
    }

    // eslint-disable-next-line func-names
    (function () {
      // eslint-disable-next-line func-names
      window.satismeter = window.satismeter || function () {
        // eslint-disable-next-line prefer-rest-params
        (window.satismeter.q = window.satismeter.q || []).push(arguments);
      };
      // @ts-ignore
      window.satismeter.l = 1 * new Date();
      const script = document.createElement('script');
      const parent = document.getElementsByTagName('script')[0].parentNode;
      // @ts-ignore
      script.async = 1;
      script.src = 'https://app.satismeter.com/satismeter.js';
      parent.appendChild(script);
    }());

    const options = {
      writeKey: process.env.SATIS_METER_WRITE_KEY,
      ...satisMeterData,
    };
    if ('satismeter' in window) {
      window.satismeter(options);
    }

    return null;
  }, []);

  return null;
};

export { SatisMeter };
